module.exports = __webpack_public_path__ + "static/media/balloon.f4d4645d.png";


//////////////////
// WEBPACK FOOTER
// ./src/balloon.png
// module id = 174
// module chunks = 0